<template>
  <button class='btn d-flex justify-content-center' :class="cssClass" type="submit" @click.prevent="submit">
    <slot />
    <moon-loader :loading="loading" color="#FFF" size="20px" class="ml-2"></moon-loader>
  </button>
</template>

<script>
import MoonLoader from 'vue-spinner/src/MoonLoader.vue'

export default {
  name: 'SubmitButton',
  components: {
    MoonLoader
  },
  props: {
    loading: {
      type: Boolean,
      defalut: false
    },
    cssClass: {
      type: String,
      default: 'btn-block'
    }
  },
  methods: {
    submit () {
      this.$emit('submit')
    }
  }
}
</script>
